import React from 'react';
import { SypacText } from '@sypac/component-library-react';
import { useTranslate } from '@tolgee/react';
import { cn } from '../../../lib/utils';
import { ContractStatus } from '../interfaces/Contract.interface';

interface ContractStatusBadgeProps {
	status?: string;
}

const STATUS_CFG = {
	to_do: {
		key: 'statuses.toDo',
		fallback: 'To do',
		bg: 'bg-gray-10',
		text: 'text-gray-80',
	},
	in_progress: {
		key: 'statuses.inProgress',
		fallback: 'In progress',
		bg: 'bg-texas-rose',
		text: 'text-gray-80',
	},
	completed: {
		key: 'statuses.completed',
		fallback: 'Completed',
		bg: 'bg-mountain-meadow',
		text: 'text-white',
	},
	expired: {
		key: 'statuses.expired',
		fallback: 'Expired',
		bg: 'bg-red',
		text: 'text-white',
	},
	canceled: {
		key: 'statuses.canceled',
		fallback: 'Canceled',
		bg: 'bg-[#E35B7F]',
		text: 'text-white',
	},
	deleted: {
		key: 'statuses.deleted',
		fallback: 'Deleted',
		bg: 'bg-shadow-blue',
		text: 'text-white',
	},
} as const;

const ContractStatusBadge: React.FC<ContractStatusBadgeProps> = ({
	status,
}) => {
	const { t } = useTranslate();
	const normalized = status ?? ContractStatus.to_do;
	const cfg =
		STATUS_CFG[normalized as keyof typeof STATUS_CFG] ?? STATUS_CFG.to_do;

	return (
		<div
			className={cn(
				'w-[100px] h-[22px] flex items-center justify-center rounded-full',
				cfg.bg,
			)}
		>
			<SypacText variant="body-regular-medium">
				<p className={cn('text-[12px] leading-[14px] mt-[2px]', cfg.text)}>
					{t(cfg.key, cfg.fallback)}
				</p>
			</SypacText>
		</div>
	);
};

export default ContractStatusBadge;
